<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Manage Media</h1>

          <!-- Media Type Tabs -->
          <b-tabs v-model="activeTabIndex" type="is-boxed" class="has-margin-bottom-15">
            <b-tab-item>
              <template #header>
                <span>Series <b-tag rounded>{{ getMediaTypeCount('series') }}</b-tag></span>
              </template>
            </b-tab-item>
            <b-tab-item>
              <template #header>
                <span>Movies <b-tag rounded>{{ getMediaTypeCount('movies') }}</b-tag></span>
              </template>
            </b-tab-item>
            <b-tab-item>
              <template #header>
                <span>TVC <b-tag rounded>{{ getMediaTypeCount('tvc') }}</b-tag></span>
              </template>
            </b-tab-item>
            <b-tab-item>
              <template #header>
                <span>Promo <b-tag rounded>{{ getMediaTypeCount('promo') }}</b-tag></span>
              </template>
            </b-tab-item>
            <b-tab-item>
              <template #header>
                <span>Filler <b-tag rounded>{{ getMediaTypeCount('filler') }}</b-tag></span>
              </template>
            </b-tab-item>
            <b-tab-item>
              <template #header>
                <span>GFX <b-tag rounded>{{ getMediaTypeCount('gfx') }}</b-tag></span>
              </template>
            </b-tab-item>
          </b-tabs>

          <div class="button-list has-text-left">
            <b-button
              type="is-primary"
              :disabled="loading"
              :class="{ 'is-loading': loading }"
              @click="exportAll('csv')"
            >
              {{ anySelected ? 'Export Selected CSV' : 'Export CSV' }}</b-button
            >
            <b-button
              type="is-primary"
              class="has-margin-left-10"
              :disabled="loading"
              :class="{ 'is-loading': loading }"
              @click="exportAll('excel')"
            >
              {{ anySelected ? 'Export Selected Excel' : 'Export Excel' }}</b-button
            >
            <b-button
              type="is-primary"
              class="has-margin-left-10"
              :disabled="loading"
              :class="{ 'is-loading': loading }"
              @click="exportCatchupSchedule"
            >
              Export Catchup Schedule</b-button
            >

            <b-button
              type="is-primary"
              :disabled="loading"
              class="has-margin-left-10"
              :class="{ 'is-loading': loading }"
              :to="{ name: 'ImportMediaFile' }"
              tag="router-link"
            >
              Import By File</b-button
            >

            <b-button
              v-if="anySelected"
              type="is-primary"
              :disabled="loading"
              class="has-margin-left-10"
              :class="{ 'is-loading': loading }"
              @click="deleteTitles"
            >
              Delete</b-button
            >
            <b-button
              type="is-warning"
              icon-left="history"
              class="has-margin-left-10"
              @click="showRecentChanges"
            >
              Recent Changes</b-button
            >
            <b-button
              type="is-info"
              icon-left="file-document-alert"
              class="has-margin-left-10"
              @click="showMissingAssetsReport = true"
            >
              Missing Assets</b-button
            >
            <b-button
              type="is-light"
              class="has-margin-left-10"
              @click="toggleSelectAll"
            >
              {{ allSelected ? 'Deselect All' : 'Select All' }}</b-button
            >
          </div>
          <b-field label="Filter by Channel">
            <BaseSelect v-model="channelFilter">
              <option value="">None</option>
              <option v-for="channel in channels">{{ channel }}</option>
            </BaseSelect>
          </b-field>
          <b-field class="has-margin-top-15">
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon="magnify"
            >
            </b-input>
          </b-field>
          <b-table
            :data="filteredMedia"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :loading="loading"
            :focusable="false"
            :mobile-cards="true"
            :paginated="true"
          >
            <template slot-scope="props">
              <b-table-column field="selected" label="" width="40">
                <b-checkbox v-model="props.row.selected" />
              </b-table-column>
              <b-table-column field="title" label="Title">
                <router-link
                  class="media-title-link"
                  :to="{ name: 'EditMedia', params: { id: props.row.id } }"
                  >{{ props.row.title }}
                  {{
                    props.row.mediadata && props.row.mediadata.seriesNo
                      ? 'S' + props.row.mediadata.seriesNo
                      : ''
                  }}</router-link
                >
              </b-table-column>

              <b-table-column
                field="mediadata.ageRestriction"
                label="PG Rating"
              >
                {{ props.row.mediadata && props.row.mediadata.ageRestriction }}
              </b-table-column>
              <b-table-column field="mediadata.mediaLength" label="Duration">
                {{ props.row.mediadata && props.row.mediadata.mediaLength }}
              </b-table-column>
              <b-table-column field="metadata.suppliers" label="Supplier">
                {{
                  props.row.metadata && props.row.metadata.suppliers
                    ? props.row.metadata.suppliers.join(', ')
                    : ''
                }}
              </b-table-column>
              <b-table-column field="metadata.genres" label="Genres">
                {{
                  props.row.metadata && props.row.metadata.genres
                    ? props.row.metadata.genres.join(', ')
                    : ''
                }}
              </b-table-column>
              <b-table-column field="description" label="Synopsis" width="300">
                <span class="synopsis-cell">{{ props.row.description }}</span>
              </b-table-column>

              <!-- <b-table-column field="user" label="Rights Owner" width="250px">
                {{ props.row.mediadata.rightsOwner }}
              </b-table-column>

              <b-table-column field="user" label="Captured By" width="250px">
                {{ props.row.first_name }}
                {{ props.row.last_name }}
              </b-table-column>

              <b-table-column field="published" label="Published">
                {{ isPublished(props.row) ? 'Yes' : 'No' }}
                <a href="" @click.prevent="publish(props.row)">
                  <b-icon
                    v-if="isPublished(props.row)"
                    icon="toggle-switch"
                  ></b-icon>
                  <b-icon
                    v-if="!isPublished(props.row)"
                    icon="toggle-switch-off"
                  ></b-icon>
                </a>
              </b-table-column>

              <b-table-column field="featured" label="Featured">
                {{ isFeatured(props.row) ? 'Yes' : 'No' }}
                <a href="" @click.prevent="markAsFeatured(props.row)">
                  <b-icon
                    v-if="isFeatured(props.row)"
                    icon="toggle-switch"
                  ></b-icon>
                  <b-icon
                    v-if="!isFeatured(props.row)"
                    icon="toggle-switch-off"
                  ></b-icon>
                </a>
              </b-table-column> -->

              <b-table-column label="">
                <b-dropdown aria-role="list">
                  <button slot="trigger" class="button is-primary">
                    <span>Actions</span>
                    <b-icon icon="menu-down"></b-icon>
                  </button>

                  <b-dropdown-item aria-role="listitem" :has-link="true"
                    ><router-link
                      :to="{
                        name: 'EditMedia',
                        params: { id: props.row.id },
                        query: {
                          admin: 1
                        }
                      }"
                      >Edit</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="props.row.media_type === 'series'"
                    aria-role="listitem"
                    :has-link="true"
                    ><router-link
                      :to="{
                        name: 'ManageEpisodes',
                        params: { id: props.row.id }
                      }"
                      >Manage Episodes</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="confirmDelete(props.row)"
                    >Delete</b-dropdown-item
                  >
                </b-dropdown>
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-medium"> </b-icon>
                  </p>
                  <p>No media yet.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </CardComponent>
    </section>
    <b-modal
      :active.sync="showConfirmModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm Delete?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to delete this title?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <button
            class="button"
            type="button"
            @click="showConfirmModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="deleteTitle()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal>
    <ExportCatchupScheduleModal
      v-if="showExportCatchupScheduleModal"
      :show="showExportCatchupScheduleModal"
      @close-modal="showExportCatchupScheduleModal = false"
    >
    </ExportCatchupScheduleModal>
    <ChangeManualQCStatusModal
      v-if="showChangeManualQCStatusModal"
      :show="showChangeManualQCStatusModal"
      :media="item"
      @close-modal="showChangeManualQCStatusModal = false"
    >
    </ChangeManualQCStatusModal>
    <ViewQcResultModal
      v-if="showViewQcResultModal"
      :show="showViewQcResultModal"
      :qc-result-id="item.qc_result_id"
      @close-modal="showViewQcResultModal = false"
      @refresh="fetchMedia"
    >
    </ViewQcResultModal>
    <RecentChangesModal
      v-if="showRecentChangesModal"
      :show="showRecentChangesModal"
      table-name="media"
      @close-modal="closeRecentChangesModal"
      @undo-change="handleUndoChange"
    />
    <MissingAssetsReportModal
      v-if="showMissingAssetsReport"
      :show="showMissingAssetsReport"
      @close-modal="showMissingAssetsReport = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import BaseSelect from '@/components/BaseSelect'
import ExportCatchupScheduleModal from '@/components/ExportCatchupScheduleModal'
import ChangeManualQCStatusModal from '@/components/ChangeManualQCStatusModal'
import RecentChangesModal from '@/components/RecentChangesModal'
import ViewQcResultModal from '@/components/ViewQcResultModal'
import MissingAssetsReportModal from '@/components/MissingAssetsReportModal'
import MediaApi from '@/api/media'
import ChannelApi from '@/api/channels'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'
export default {
  name: 'ManageMedia',
  components: {
    CardComponent,
    ExportCatchupScheduleModal,
    BaseSelect,
    ChangeManualQCStatusModal,
    ViewQcResultModal,
    RecentChangesModal,
    MissingAssetsReportModal
  },
  mixins: [Filters, Utils],
  metaInfo: {
    title: 'Manage Titles'
  },
  computed: {
    ...mapGetters(['user']),
    anySelected() {
      if (this.filteredMedia && this.filteredMedia.length > 0) {
        return this.filteredMedia.find(item => item.selected)
      }
      return false
    },
    allSelected() {
      if (this.filteredMedia && this.filteredMedia.length > 0) {
        return this.filteredMedia.every(item => item.selected)
      }
      return false
    },
    activeMediaType() {
      return this.mediaTypes[this.activeTabIndex] || 'series'
    },
    filteredMedia() {
      let media = this.media

      // Filter by media type (tab)
      media = media.filter(item => item.media_type === this.activeMediaType)

      // Filter by channel - check both metadata.channels and metadata.suppliers
      // (supplier = channel name in BMS architecture)
      if (this.channelFilter != '') {
        media = media.filter(item => {
          if (!item || !item.metadata) return false
          const channels = item.metadata.channels || []
          const suppliers = item.metadata.suppliers || []
          // Check channels array (string or object format)
          if (channels.includes(this.channelFilter)) return true
          if (channels[0] && channels[0].name === this.channelFilter) return true
          // Fallback: check suppliers array (supplier = channel in BMS)
          if (suppliers.includes(this.channelFilter)) return true
          return false
        })
      }

      // Filter by search term
      if (this.search !== '' && this.media.length > 0) {
        let query = this.search.toLowerCase()
        media = media.filter(item => item.title.toLowerCase().includes(query))
      }

      // Sort alphabetically by title
      const sorted = [...media].sort((a, b) => {
        const titleA = (a.title || '').toLowerCase()
        const titleB = (b.title || '').toLowerCase()
        return titleA.localeCompare(titleB)
      })
      return sorted
    },
    // Get count of media items per type (for tab badges)
    mediaTypeCounts() {
      const counts = {
        series: 0,
        movie: 0,
        tvc: 0,
        promo: 0,
        filler: 0,
        gfx: 0
      }
      this.media.forEach(item => {
        if (counts.hasOwnProperty(item.media_type)) {
          counts[item.media_type]++
        }
      })
      return counts
    }
  },
  async created() {
    this.fetchMedia()
    const channels = await ChannelApi.getAll()
    this.channels = channels.map(item => item.name)
  },
  watch: {
    // When search changes, check if results exist in a different tab and switch to it
    search(newSearch) {
      if (newSearch && newSearch.length >= 2) {
        const query = newSearch.toLowerCase()
        // Check if any results in current tab
        const currentTabResults = this.media.filter(
          item => item.media_type === this.activeMediaType && item.title.toLowerCase().includes(query)
        )
        // If no results in current tab, find which tab has results
        if (currentTabResults.length === 0) {
          for (let i = 0; i < this.mediaTypes.length; i++) {
            const type = this.mediaTypes[i]
            const resultsInType = this.media.filter(
              item => item.media_type === type && item.title.toLowerCase().includes(query)
            )
            if (resultsInType.length > 0) {
              this.activeTabIndex = i
              break
            }
          }
        }
      }
    }
  },
  data() {
    return {
      loading: true,
      media: [],
      channels: [],
      search: '',
      showConfirmModal: false,
      item: {},
      channelFilter: '',
      activeTabIndex: 0, // Default to series tab (index 0)
      mediaTypes: ['series', 'movies', 'tvc', 'promo', 'filler', 'gfx'],
      showExportCatchupScheduleModal: false,
      showChangeManualQCStatusModal: false,
      showViewQcResultModal: false,
      showDetailsModal: false,
      showRecentChangesModal: false,
      showMissingAssetsReport: false
    }
  },
  methods: {
    ...mapActions(['getUser']),
    toggleSelectAll() {
      const newValue = !this.allSelected
      // Use Vue.set for proper reactivity on filtered items
      this.filteredMedia.forEach(item => {
        this.$set(item, 'selected', newValue)
      })
      // Force reactivity update
      this.media = [...this.media]
    },
    showQcJobResult(item) {
      this.item = item
      this.showViewQcResultModal = true
    },
    changeManualStatus(item) {
      this.item = item
      this.showChangeManualQCStatusModal = true
    },
    deleteTitles() {
      let items = this.filteredMedia.filter(item => item.selected)
      this.$buefy.dialog.confirm({
        message: `Are you sure you want to delete the ${items.length} titles?`,
        onConfirm: async () => {
          this.loading = true
          await MediaApi.removeMultiple(items.map(item => item.id))
          this.$buefy.toast.open({
            message: 'Titles removed successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.loading = false
          this.media = this.media.filter(item => !item.selected)
        }
      })
    },
    exportCatchupSchedule() {
      this.showExportCatchupScheduleModal = true
    },
    async exportAll(type) {
      // Get selected media IDs if any are selected
      const selectedIds = this.filteredMedia
        .filter(item => item.selected)
        .map(item => item.id)

      if (type === 'csv') {
        await MediaApi.exportCsv(selectedIds.length > 0 ? selectedIds : null)
      } else {
        await MediaApi.exportExcel(selectedIds.length > 0 ? selectedIds : null)
      }
    },
    publish(item) {
      MediaApi.publish({
        mediaId: item.id,
        published: item.published === 0 ? 1 : 0
      })
        .then(() => {
          let found = this.media.find(mediaItem => mediaItem.id === item.id)
          found.published = item.published === 0 ? 1 : 0
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error changing media publish status',
            position: 'is-top',
            type: 'is-danger'
          })
        })
    },
    markAsFeatured(item) {
      MediaApi.markAsFeatured({
        mediaId: item.id,
        featured: item.featured === 0 ? 1 : 0
      })
        .then(() => {
          let found = this.media.find(mediaItem => mediaItem.id === item.id)
          found.featured = item.featured === 0 ? 1 : 0
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error changing media featured status',
            position: 'is-top',
            type: 'is-danger'
          })
        })
    },
    isPublished(item) {
      return item && item.published === 1
    },
    isFeatured(item) {
      return item && item.featured === 1
    },
    confirmDelete(item) {
      this.showConfirmModal = true
      this.item = item
    },
    deleteTitle() {
      MediaApi.remove({
        mediaId: this.item.id
      })
        .then(() => {
          this.$buefy.toast.open({
            message: 'Media deleted successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.fetchMedia()
          this.showConfirmModal = false
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error deleting media',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    },
    async fetchMedia() {
      this.loading = true
      MediaApi.getAll().then(media => {
        media.forEach(item => {
          if (item.mediadata && item.mediadata !== '') {
            item.mediadata = JSON.parse(item.mediadata)
          }
          if (item.metadata && item.metadata !== '') {
            item.metadata = JSON.parse(item.metadata)
          }
          // QC status comes from media's qc_status field
          item.qcstatus = item.qc_status || null
        })
        // Sort alphabetically by title
        media.sort((a, b) => {
          const titleA = (a.title || '').toLowerCase()
          const titleB = (b.title || '').toLowerCase()
          return titleA.localeCompare(titleB)
        })
        this.media = media
        this.loading = false
      })
    },
    getMediaTypeCount(mediaType) {
      return this.mediaTypeCounts[mediaType] || 0
    },
    showRecentChanges() {
      this.showRecentChangesModal = true
    },
    closeRecentChangesModal() {
      this.showRecentChangesModal = false
    },
    handleUndoChange() {
      // Refresh media list after undo
      this.fetchMedia()
      this.$buefy.toast.open({
        message: 'Change undone successfully',
        type: 'is-success',
        position: 'is-top'
      })
    }
  }
}
</script>

<style>
.table th,
.table td {
  font-size: 12px;
}

/* Media type tabs styling */
.b-tabs .tab-content {
  padding: 0;
}

.b-tabs .tabs {
  margin-bottom: 1rem;
}

.b-tabs .tabs li a .tag {
  margin-left: 0.5rem;
  font-size: 0.7rem;
}

.media-title-link {
  font-size: 14px !important;
  font-weight: 600 !important;
}

.synopsis-cell {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 300px;
}
</style>
